<script>
    import {afterUpdate, onMount} from "svelte";

    export let color;
    export let comment;

    $: state = !['Цветной', 'Неокрашенный', 'Покраска'].includes(color);

    let selected = '';
    let showRalList = false;
    let searchRal = '';

    const colors = [
        ["RAL1000", "/resources/img/ral/1000.jpg"],
        ["RAL1001", "/resources/img/ral/1001.jpg"],
        ["RAL1002", "/resources/img/ral/1002.jpg"],
        ["RAL1003", "/resources/img/ral/1003.jpg"],
        ["RAL1004", "/resources/img/ral/1004.jpg"],
        ["RAL1005", "/resources/img/ral/1005.jpg"],
        ["RAL1006", "/resources/img/ral/1006.jpg"],
        ["RAL1007", "/resources/img/ral/1007.jpg"],
        ["RAL1011", "/resources/img/ral/1011.jpg"],
        ["RAL1012", "/resources/img/ral/1012.jpg"],
        ["RAL1013", "/resources/img/ral/1013.jpg"],
        ["RAL1014", "/resources/img/ral/1014.jpg"],
        ["RAL1015", "/resources/img/ral/1015.jpg"],
        ["RAL1016", "/resources/img/ral/1016.jpg"],
        ["RAL1018", "/resources/img/ral/1018.jpg"],
        ["RAL1019", "/resources/img/ral/1019.jpg"],
        ["RAL1020", "/resources/img/ral/1020.jpg"],
        ["RAL1021", "/resources/img/ral/1021.jpg"],
        ["RAL1023", "/resources/img/ral/1023.jpg"],
        ["RAL1024", "/resources/img/ral/1024.jpg"],
        ["RAL1026", "/resources/img/ral/1026.jpg"],
        ["RAL1027", "/resources/img/ral/1027.jpg"],
        ["RAL1028", "/resources/img/ral/1028.jpg"],
        ["RAL1032", "/resources/img/ral/1032.jpg"],
        ["RAL1033", "/resources/img/ral/1033.jpg"],
        ["RAL1034", "/resources/img/ral/1034.jpg"],
        ["RAL1035", "/resources/img/ral/1035.jpg"],
        ["RAL1036", "/resources/img/ral/1036.jpg"],
        ["RAL1037", "/resources/img/ral/1037.jpg"],
        ["RAL2000", "/resources/img/ral/2000.jpg"],
        ["RAL2001", "/resources/img/ral/2001.jpg"],
        ["RAL2002", "/resources/img/ral/2002.jpg"],
        ["RAL2003", "/resources/img/ral/2003.jpg"],
        ["RAL2004", "/resources/img/ral/2004.jpg"],
        ["RAL2005", "/resources/img/ral/2005.jpg"],
        ["RAL2007", "/resources/img/ral/2007.jpg"],
        ["RAL2008", "/resources/img/ral/2008.jpg"],
        ["RAL2009", "/resources/img/ral/2009.jpg"],
        ["RAL2010", "/resources/img/ral/2010.jpg"],
        ["RAL2011", "/resources/img/ral/2011.jpg"],
        ["RAL2012", "/resources/img/ral/2012.jpg"],
        ["RAL2013", "/resources/img/ral/2013.jpg"],
        ["RAL3000", "/resources/img/ral/3000.jpg"],
        ["RAL3001", "/resources/img/ral/3001.jpg"],
        ["RAL3002", "/resources/img/ral/3002.jpg"],
        ["RAL3003", "/resources/img/ral/3003.jpg"],
        ["RAL3004", "/resources/img/ral/3004.jpg"],
        ["RAL3005", "/resources/img/ral/3005.jpg"],
        ["RAL3007", "/resources/img/ral/3007.jpg"],
        ["RAL3009", "/resources/img/ral/3009.jpg"],
        ["RAL3011", "/resources/img/ral/3011.jpg"],
        ["RAL3012", "/resources/img/ral/3012.jpg"],
        ["RAL3013", "/resources/img/ral/3013.jpg"],
        ["RAL3014", "/resources/img/ral/3014.jpg"],
        ["RAL3015", "/resources/img/ral/3015.jpg"],
        ["RAL3016", "/resources/img/ral/3016.jpg"],
        ["RAL3017", "/resources/img/ral/3017.jpg"],
        ["RAL3018", "/resources/img/ral/3018.jpg"],
        ["RAL3020", "/resources/img/ral/3020.jpg"],
        ["RAL3022", "/resources/img/ral/3022.jpg"],
        ["RAL3024", "/resources/img/ral/3024.jpg"],
        ["RAL3026", "/resources/img/ral/3026.jpg"],
        ["RAL3027", "/resources/img/ral/3027.jpg"],
        ["RAL3028", "/resources/img/ral/3028.jpg"],
        ["RAL3031", "/resources/img/ral/3031.jpg"],
        ["RAL3032", "/resources/img/ral/3032.jpg"],
        ["RAL3033", "/resources/img/ral/3033.jpg"],
        ["RAL4001", "/resources/img/ral/4001.jpg"],
        ["RAL4002", "/resources/img/ral/4002.jpg"],
        ["RAL4003", "/resources/img/ral/4003.jpg"],
        ["RAL4004", "/resources/img/ral/4004.jpg"],
        ["RAL4005", "/resources/img/ral/4005.jpg"],
        ["RAL4006", "/resources/img/ral/4006.jpg"],
        ["RAL4007", "/resources/img/ral/4007.jpg"],
        ["RAL4008", "/resources/img/ral/4008.jpg"],
        ["RAL4009", "/resources/img/ral/4009.jpg"],
        ["RAL4010", "/resources/img/ral/4010.jpg"],
        ["RAL4011", "/resources/img/ral/4011.jpg"],
        ["RAL4012", "/resources/img/ral/4012.jpg"],
        ["RAL5000", "/resources/img/ral/5000.jpg"],
        ["RAL5001", "/resources/img/ral/5001.jpg"],
        ["RAL5002", "/resources/img/ral/5002.jpg"],
        ["RAL5003", "/resources/img/ral/5003.jpg"],
        ["RAL5004", "/resources/img/ral/5004.jpg"],
        ["RAL5005", "/resources/img/ral/5005.jpg"],
        ["RAL5007", "/resources/img/ral/5007.jpg"],
        ["RAL5008", "/resources/img/ral/5008.jpg"],
        ["RAL5009", "/resources/img/ral/5009.jpg"],
        ["RAL5010", "/resources/img/ral/5010.jpg"],
        ["RAL5011", "/resources/img/ral/5011.jpg"],
        ["RAL5012", "/resources/img/ral/5012.jpg"],
        ["RAL5013", "/resources/img/ral/5013.jpg"],
        ["RAL5014", "/resources/img/ral/5014.jpg"],
        ["RAL5015", "/resources/img/ral/5015.jpg"],
        ["RAL5017", "/resources/img/ral/5017.jpg"],
        ["RAL5018", "/resources/img/ral/5018.jpg"],
        ["RAL5019", "/resources/img/ral/5019.jpg"],
        ["RAL5020", "/resources/img/ral/5020.jpg"],
        ["RAL5021", "/resources/img/ral/5021.jpg"],
        ["RAL5022", "/resources/img/ral/5022.jpg"],
        ["RAL5023", "/resources/img/ral/5023.jpg"],
        ["RAL5024", "/resources/img/ral/5024.jpg"],
        ["RAL5025", "/resources/img/ral/5025.jpg"],
        ["RAL5026", "/resources/img/ral/5026.jpg"],
        ["RAL6000", "/resources/img/ral/6000.jpg"],
        ["RAL6001", "/resources/img/ral/6001.jpg"],
        ["RAL6002", "/resources/img/ral/6002.jpg"],
        ["RAL6003", "/resources/img/ral/6003.jpg"],
        ["RAL6004", "/resources/img/ral/6004.jpg"],
        ["RAL6005", "/resources/img/ral/6005.jpg"],
        ["RAL6006", "/resources/img/ral/6006.jpg"],
        ["RAL6007", "/resources/img/ral/6007.jpg"],
        ["RAL6008", "/resources/img/ral/6008.jpg"],
        ["RAL6009", "/resources/img/ral/6009.jpg"],
        ["RAL6010", "/resources/img/ral/6010.jpg"],
        ["RAL6011", "/resources/img/ral/6011.jpg"],
        ["RAL6012", "/resources/img/ral/6012.jpg"],
        ["RAL6013", "/resources/img/ral/6013.jpg"],
        ["RAL6014", "/resources/img/ral/6014.jpg"],
        ["RAL6015", "/resources/img/ral/6015.jpg"],
        ["RAL6016", "/resources/img/ral/6016.jpg"],
        ["RAL6017", "/resources/img/ral/6017.jpg"],
        ["RAL6018", "/resources/img/ral/6018.jpg"],
        ["RAL6019", "/resources/img/ral/6019.jpg"],
        ["RAL6020", "/resources/img/ral/6020.jpg"],
        ["RAL6021", "/resources/img/ral/6021.jpg"],
        ["RAL6022", "/resources/img/ral/6022.jpg"],
        ["RAL6024", "/resources/img/ral/6024.jpg"],
        ["RAL6025", "/resources/img/ral/6025.jpg"],
        ["RAL6026", "/resources/img/ral/6026.jpg"],
        ["RAL6027", "/resources/img/ral/6027.jpg"],
        ["RAL6028", "/resources/img/ral/6028.jpg"],
        ["RAL6029", "/resources/img/ral/6029.jpg"],
        ["RAL6032", "/resources/img/ral/6032.jpg"],
        ["RAL6033", "/resources/img/ral/6033.jpg"],
        ["RAL6034", "/resources/img/ral/6034.jpg"],
        ["RAL6035", "/resources/img/ral/6035.jpg"],
        ["RAL6036", "/resources/img/ral/6036.jpg"],
        ["RAL6037", "/resources/img/ral/6037.jpg"],
        ["RAL6038", "/resources/img/ral/6038.jpg"],
        ["RAL7000", "/resources/img/ral/7000.jpg"],
        ["RAL7001", "/resources/img/ral/7001.jpg"],
        ["RAL7002", "/resources/img/ral/7002.jpg"],
        ["RAL7003", "/resources/img/ral/7003.jpg"],
        ["RAL7004", "/resources/img/ral/7004.jpg"],
        ["RAL7005", "/resources/img/ral/7005.jpg"],
        ["RAL7006", "/resources/img/ral/7006.jpg"],
        ["RAL7008", "/resources/img/ral/7008.jpg"],
        ["RAL7009", "/resources/img/ral/7009.jpg"],
        ["RAL7010", "/resources/img/ral/7010.jpg"],
        ["RAL7011", "/resources/img/ral/7011.jpg"],
        ["RAL7012", "/resources/img/ral/7012.jpg"],
        ["RAL7013", "/resources/img/ral/7013.jpg"],
        ["RAL7015", "/resources/img/ral/7015.jpg"],
        ["RAL7016", "/resources/img/ral/7016.jpg"],
        ["RAL7021", "/resources/img/ral/7021.jpg"],
        ["RAL7022", "/resources/img/ral/7022.jpg"],
        ["RAL7023", "/resources/img/ral/7023.jpg"],
        ["RAL7024", "/resources/img/ral/7024.jpg"],
        ["RAL7026", "/resources/img/ral/7026.jpg"],
        ["RAL7030", "/resources/img/ral/7030.jpg"],
        ["RAL7031", "/resources/img/ral/7031.jpg"],
        ["RAL7032", "/resources/img/ral/7032.jpg"],
        ["RAL7033", "/resources/img/ral/7033.jpg"],
        ["RAL7034", "/resources/img/ral/7034.jpg"],
        ["RAL7035", "/resources/img/ral/7035.jpg"],
        ["RAL7036", "/resources/img/ral/7036.jpg"],
        ["RAL7037", "/resources/img/ral/7037.jpg"],
        ["RAL7038", "/resources/img/ral/7038.jpg"],
        ["RAL7039", "/resources/img/ral/7039.jpg"],
        ["RAL7040", "/resources/img/ral/7040.jpg"],
        ["RAL7042", "/resources/img/ral/7042.jpg"],
        ["RAL7043", "/resources/img/ral/7043.jpg"],
        ["RAL7044", "/resources/img/ral/7044.jpg"],
        ["RAL7045", "/resources/img/ral/7045.jpg"],
        ["RAL7046", "/resources/img/ral/7046.jpg"],
        ["RAL7047", "/resources/img/ral/7047.jpg"],
        ["RAL7048", "/resources/img/ral/7048.jpg"],
        ["RAL8000", "/resources/img/ral/8000.jpg"],
        ["RAL8001", "/resources/img/ral/8001.jpg"],
        ["RAL8002", "/resources/img/ral/8002.jpg"],
        ["RAL8003", "/resources/img/ral/8003.jpg"],
        ["RAL8004", "/resources/img/ral/8004.jpg"],
        ["RAL8007", "/resources/img/ral/8007.jpg"],
        ["RAL8008", "/resources/img/ral/8008.jpg"],
        ["RAL8011", "/resources/img/ral/8011.jpg"],
        ["RAL8012", "/resources/img/ral/8012.jpg"],
        ["RAL8014", "/resources/img/ral/8014.jpg"],
        ["RAL8015", "/resources/img/ral/8015.jpg"],
        ["RAL8016", "/resources/img/ral/8016.jpg"],
        ["RAL8017", "/resources/img/ral/8017.jpg"],
        ["RAL8019", "/resources/img/ral/8019.jpg"],
        ["RAL8022", "/resources/img/ral/8022.jpg"],
        ["RAL8023", "/resources/img/ral/8023.jpg"],
        ["RAL8024", "/resources/img/ral/8024.jpg"],
        ["RAL8025", "/resources/img/ral/8025.jpg"],
        ["RAL8028", "/resources/img/ral/8028.jpg"],
        ["RAL8029", "/resources/img/ral/8029.jpg"],
        ["RAL9001", "/resources/img/ral/9001.jpg"],
        ["RAL9002", "/resources/img/ral/9002.jpg"],
        ["RAL9003", "/resources/img/ral/9003.jpg"],
        ["RAL9004", "/resources/img/ral/9004.jpg"],
        ["RAL9005", "/resources/img/ral/9005.jpg"],
        ["RAL9006", "/resources/img/ral/9006.jpg"],
        ["RAL9007", "/resources/img/ral/9007.jpg"],
        ["RAL9010", "/resources/img/ral/9010.jpg"],
        ["RAL9011", "/resources/img/ral/9011.jpg"],
        ["RAL9016", "/resources/img/ral/9016.jpg"],
        ["RAL9017", "/resources/img/ral/9017.jpg"],
        ["RAL9018", "/resources/img/ral/9018.jpg"],
        ["RAL9022", "/resources/img/ral/9022.jpg"],
        ["RAL9023", "/resources/img/ral/9023.jpg"],
    ];

    // Фильтруем цвета
    $: filteredColors = searchRal
        ? colors.filter(([code]) => code.toLowerCase().includes(searchRal.toLowerCase()))
        : colors;

    const handler = (value) => {
        selected = searchRal = value
        showRalList = false

        comment = comment.replace(/RAL\d{4}/, '').trim();
        comment = `${selected} ${comment}`.trim();
    }

    afterUpdate(() => {
        if (state) {
            selected = '';
            if (comment) {
                comment = comment.replace(/RAL\d{4}/, '');
            }
        } else {

            if (comment) {
                let match = comment.match(/RAL\d{4}/);
                if (match) {
                    selected = match[0];
                }
            }


        }
    })
</script>

{#if !state}
    <div class="col-12">
        <div class="form-group boxed">
            <div class="input-wrapper">
                <label class="form-label" for="ralPoisk">Цвет RAL</label>

                <!-- Текстовое поле для ввода и поиска -->
                <input  id="ralPoisk"
                        type="text"
                        class="form-control"
                        placeholder="Введите RAL..."
                        bind:value={searchRal}
                        on:focus={() => showRalList = true}
                        on:blur={() => setTimeout(() => showRalList = false, 200)}
                        autocomplete="off"
                />

                <!-- Кастомный список опций -->
                {#if showRalList && filteredColors.length > 0}
                    <div class="custom-select-list" style="position: absolute; z-index: 1000; width: 100%; background: white; border: 1px solid #ccc; border-top: none; max-height: 200px; overflow-y: auto;">
                        {#each filteredColors as [value]}
                            <div
                                class="custom-option px-3 py-2 cursor-pointer hover:bg-gray-100"
                                on:click={() => handler(value)}
                            >
                                {value}
                            </div>
                        {/each}
                    </div>
                {/if}

                {#if selected}
                    <div class="input-group-append">
                        <img class="input-group-text p-0" src="https://iem.plisse.ltd/resources/img/ral/{selected.replace('RAL', '')}.jpg" alt={selected} />
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    img {
        height: 42px!important;
    }
    .custom-select-list {
        border-radius: 0.375rem; /* Соответствует стилям form-control */
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        border: 1px solid #ced4da; /* Используем стандартный цвет границы */
        border-top: none; /* Убираем верхнюю границу, чтобы она не дублировалась с input */
    }
    .custom-option {
        cursor: pointer;
        padding: 0.375rem 0.75rem; /* Соответствует внутреннему отступу option */
    }
    .custom-option:hover {
        background-color: #e9ecef; /* Bootstrap hover bg */
    }
</style>
